import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state: [],
  mutations: {
    INITIAL_STORE(state) {
      // console.log(localStorage.getItem('store'))
      if (localStorage.getItem('store')) {
        // console.log('localSTorage')
        // console.log(localStorage.getItem('store'))
        Object.assign(state, JSON.parse(localStorage.getItem('store')))
      }
    },
    ADD_NOTIFICATION(state, payload) {
      state.push(payload)
    },
    DELETE_NOTIFICATION(state, payload) {
      const index = state.findIndex(item => item === payload)
      state.splice(index, 1)
    },
  },
  actions: {
    ADD({ commit }, { payload }) {
      commit('ADD_NOTIFICATION', payload)
    },
    DELETE({ commit }, { payload }) {
      commit('DELETE_NOTIFICATION', payload)
    },
  },
  getters: {
    notification: state => state,
  },
}
